export enum DocType {
    Other = 0,
    PDF = 1,
    Image = 2
}